import styled from 'styled-components';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const StatisticContainer = styled.section`
  /*
  padding-top: 160px;
  padding-bottom: 270px;
  */

  ${breakpoints.down('sm')} {
    padding-top: 60px;
    padding-bottom: 60px;
  }

  ${breakpoints.down('xs')} {
    text-align: center;
  }

  .statistic {
    &__items {
      margin-top: 60px;

      ${breakpoints.down('xs')} {
        margin-top: 50px;

        .MuiGrid-spacing-xs-4 {
          width: calc(100% + 20px);
          margin: -10px;
        }

        .MuiGrid-spacing-xs-4 > .MuiGrid-item {
          padding: 10px;
        }
      }
    }
  }
`;

export default StatisticContainer;
